<script>
    import BookNow from "./MenuComponents/BookNow.svelte";
    import Images from "./MenuComponents/Images.svelte";
    import InfoTab from "./MenuComponents/InfoTab.svelte";

    export let activeTab;
</script>

<style>
    @media  (max-width: 768px) {
        .content {
            max-height: calc(100dvh - 53px - 230px) !important;
            overflow-y: auto;

        }
    }
    .content {
        display: flex;
        max-height: 100%;
        flex-direction: column;
    }
</style>

<div class="content">
    {#if activeTab === 'schedule'}
        <BookNow/>
    {:else if activeTab === 'image'}
        <Images/>
    {:else if activeTab === 'info'}
        <InfoTab/>
    {/if}
</div>
